<div
    class="code-container"
    [ngClass]="classes"
    [style.--fdx-collapsed-rows]="collapsedRows">
    <ng-content></ng-content>
    @if (showToggle) {
        <div class="fdx-code-toggle">
            <button
                type="button"
                class="btn btn-outline-secondary"
                triggers="mouseenter:mouseleave"
                placement="right"
                [ngbTooltip]="toggleText"
                (click)="toggle()">
                <fa-icon
                    class="no-margin"
                    [icon]="icon">
                </fa-icon>
            </button>
        </div>
    }
</div>
